require("./src/style/reset.css")
require("./src/style/prism-original.css")
require("./src/style/link-card.css")

// Service Worker更新の最適化
export const onClientEntry = () => {
  // Service Worker更新の最適化
  if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload()
    })
  }
}

// 本番環境のみでhydration関数を置き換え
// React error #418の修正は本番環境でのみ必要
// 開発環境では標準のhydrationを使用

export const replaceHydrateFunction = () => {
  // 本番環境でのみReact 18のcreateRootを使用
  if (process.env.NODE_ENV === "production") {
    return (element, container) => {
      const { createRoot } = require("react-dom/client")
      const root = createRoot(container)
      root.render(element)
    }
  }

  // 開発環境では何もしない（デフォルトのhydrationを使用）
  return undefined
}
